import {createSlice, PayloadAction} from "@reduxjs/toolkit";


import {StudentInfo} from "../../types/student-info/studentInfoSchema";


interface StudentState {
    data: StudentInfo | null;
    loading: boolean;
    error: string | null;
}

const initialState: StudentState = {
    data: null,
    loading: false,
    error: null,
};

const studentInfoSlice = createSlice({
    name: "student",
    initialState,
    reducers: {
        setStudentData: (state, action: PayloadAction<StudentInfo | null>
        ) => {
            state.data = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export const { setStudentData, setLoading, setError } = studentInfoSlice.actions;

export const studentInfoReducer = studentInfoSlice.reducer;